import { useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowDownUp, Trash2 } from "lucide-react";

interface ColumnsProps {
  onClickDelete: (data: any) => void;
}

const FactoryWasteColumn = ({ onClickDelete }: ColumnsProps) => {
  const FactoryWasteColumn = useMemo(
    () => [
      {
        header: "سال زارع",
        accessorKey: "crop_year_name",
        enableColumnFilter: false,
      },
      {
        header: "وزن شکر دریافتی از کارخانه",
        accessorKey: "waste_weight_received_factory",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "بهای تفاله دریافتی از کارخانه",
        accessorKey: "waste_price_received_factory",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: " کارخانه",
        accessorKey: "factory_name",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <Link to="#" onClick={() => onClickDelete(cell.row.original)}>
              <span className="rounded p-2 w-20 ml-3 bg-red-800 text-white">
                حذف
              </span>
            </Link>
            
          </div>
        ),
      },
    ],
    []
  );

  return FactoryWasteColumn;
};

export default FactoryWasteColumn;
